import { ANALYSIS } from "../constants";
import { instance } from "../../axios";

// get analysis by study id
let getAnalysesByStudy = (studyId) => {
  return (dispatch) => {
    dispatch({
      type: ANALYSIS.ANALYSIS_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/analysis/study/${studyId}`,
    })
      .then((results) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let getAnalysis = (id) => {
  return (dispatch) => {
    dispatch({
      type: ANALYSIS.ANALYSIS_GET_ONE,
    });
    instance({
      method: "GET",
      url: `/analysis/${id}`,
    })
      .then((results) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_GET_ONE_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_GET_ONE_FAILURE,
          payload: error,
        });
      });
  };
};

let updateAnalysis = (body) => {
  return (dispatch) => {
    dispatch({
      type: ANALYSIS.ANALYSIS_UPDATE,
    });
    return instance
      .put(`/analysis/${body.id}`, body)
      .then((results) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_UPDATE_SUCCESS,
          payload: results.data,
        });
        return results.data;
      })
      .catch((error) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_UPDATE_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

let createAnalysis = (body) => {
  return (dispatch) => {
    dispatch({
      type: ANALYSIS.ANALYSIS_CREATE,
    });
    return instance
      .post("/analysis", body)
      .then((results) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_CREATE_SUCCESS,
          payload: results.data,
        });
        return results.data;
      })
      .catch((error) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_CREATE_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

let deleteAnalysis = (id) => {
  return (dispatch) => {
    dispatch({
      type: ANALYSIS.ANALYSIS_DELETE,
    });
    return instance
      .delete(`/analysis/${id}`)
      .then((results) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_DELETE_SUCCESS,
          payload: id,
        });
        return results.data;
      })
      .catch((error) => {
        dispatch({
          type: ANALYSIS.ANALYSIS_DELETE_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

export {
  getAnalysis,
  getAnalysesByStudy,
  updateAnalysis,
  createAnalysis,
  deleteAnalysis,
};
